/*!
 * @he-tree/dnd-utils v0.1.0-alpha.1
 * Author: phphe <phphe@outlook.com> (https://github.com/phphe)
 * Homepage: null
 * Released under the MIT License.
 */
import * as hp from 'helper-js';
import DragEventService from 'drag-event-service';

const instances = new Map();
const context = {
  triggerElement: null,
  dragElement: null,
  internal: false,
  dropEffect: "none",
  preventDefault: false
};
const ctx = context;

function syncDropEffect(e) {
  if (e.dataTransfer) {
    e.dataTransfer.dropEffect = ctx.dropEffect;
  }
} //


function extendedDND(root) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (instances.has(root)) {
    throw "Already registered on specified element";
  } // opt is same with thisInstance


  const opt = { ...options
  }; // clone options object

  const ins = opt;
  hp.objectAssignIfNoKey(opt, defaultOptions);
  DragEventService.on(root, "start", beforeDragStart, {
    touchArgs: [{
      passive: true
    }]
  }); // methods

  function beforeDragStart(e) {
    var _opt$beforeDragStart;

    const node = e.target; // only process element node

    if (node.nodeType === Node.ELEMENT_NODE) {
      ctx.triggerElement = node;
    }

    const el = node; // if in ingoreHTMLTags

    if (opt.ingoreHTMLTags && el.tagName) {
      if (opt.ingoreHTMLTags.find(tag => tag.toUpperCase() === el.tagName)) {
        return;
      }
    }

    const dragElement = (_opt$beforeDragStart = opt.beforeDragStart) === null || _opt$beforeDragStart === void 0 ? void 0 : _opt$beforeDragStart.call(opt, e);

    if (dragElement) {
      dragElement.setAttribute("draggable", "true");
      ctx.dragElement = dragElement;
    }
  }

  function onDragStart(e) {
    var _opt$onDragStart;

    ctx.internal = true;
    (_opt$onDragStart = opt.onDragStart) === null || _opt$onDragStart === void 0 ? void 0 : _opt$onDragStart.call(opt, e);
    syncDropEffect(e);
  }

  function onDrag(e) {
    var _opt$onDrag;

    (_opt$onDrag = opt.onDrag) === null || _opt$onDrag === void 0 ? void 0 : _opt$onDrag.call(opt, e);
    syncDropEffect(e);
  }

  function onDragEnd(e) {
    var _opt$onDragEnd;

    (_opt$onDragEnd = opt.onDragEnd) === null || _opt$onDragEnd === void 0 ? void 0 : _opt$onDragEnd.call(opt, e);
    ctx.internal = false;

    if (ctx.dragElement) {
      ctx.dragElement.removeAttribute("draggable");
    }

    ctx.triggerElement = null;
    ctx.dragElement = null;
    ctx.dropEffect = "none";
  } // follow is called on target instance


  const destroyDropZoneListeners = extendedDropZone(root, {
    onDragLeave(e) {
      var _opt$onDragLeave;

      (_opt$onDragLeave = opt.onDragLeave) === null || _opt$onDragLeave === void 0 ? void 0 : _opt$onDragLeave.call(opt, e);
      syncDropEffect(e);
    },

    onDragEnter(e) {
      var _opt$onDragEnter;

      ins.ifPreventDefault(e) && e.preventDefault();
      (_opt$onDragEnter = opt.onDragEnter) === null || _opt$onDragEnter === void 0 ? void 0 : _opt$onDragEnter.call(opt, e);
      syncDropEffect(e);
    },

    onDragOver(e) {
      var _opt$onDragOver;

      ins.ifPreventDefault(e) && e.preventDefault();
      (_opt$onDragOver = opt.onDragOver) === null || _opt$onDragOver === void 0 ? void 0 : _opt$onDragOver.call(opt, e);
      syncDropEffect(e);
    },

    onDrop(e) {
      var _opt$onDrop;

      ins.ifPreventDefault(e) && e.preventDefault();
      (_opt$onDrop = opt.onDrop) === null || _opt$onDrop === void 0 ? void 0 : _opt$onDrop.call(opt, e);
    },

    onEnter(e) {
      var _opt$onEnter;

      (_opt$onEnter = opt.onEnter) === null || _opt$onEnter === void 0 ? void 0 : _opt$onEnter.call(opt, e);
    },

    onLeave(e) {
      var _opt$onLeave;

      (_opt$onLeave = opt.onLeave) === null || _opt$onLeave === void 0 ? void 0 : _opt$onLeave.call(opt, e);
    }

  });
  hp.on(root, "dragstart", onDragStart);
  hp.on(root, "drag", onDrag);
  hp.on(root, "dragend", onDragEnd); // define the destroy function
  // 定义销毁/退出的方法

  const destroy = () => {
    DragEventService.off(root, "start", beforeDragStart, {
      touchArgs: [{
        passive: true
      }]
    });
    hp.off(root, "dragstart", onDragStart);
    hp.off(root, "drag", onDrag);
    hp.off(root, "dragend", onDragEnd);
    destroyDropZoneListeners();
    instances.delete(root);
  };

  Object.assign(opt, {
    root,
    destroy
  });
  instances.set(root, ins);
  return ins;
}
const defaultOptions = {
  ingoreHTMLTags: ["INPUT", "TEXTAREA", "SELECT", "OPTGROUP", "OPTION"],

  ifPreventDefault(event) {
    if (context.dragElement) {
      return true;
    }

    return ctx.preventDefault;
  },

  beforeDragStart(event) {},

  onDragStart(event) {},

  onDrag(event) {},

  onDragEnter(event) {},

  onDragLeave(event) {},

  onDragOver(event) {},

  onDragEnd(event) {},

  onDrop(event) {}

};
function extendedDropZone(el) {
  let opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let entered = false;

  const onEnter = e => {
    var _opt$onEnter2;

    entered = true;
    (_opt$onEnter2 = opt.onEnter) === null || _opt$onEnter2 === void 0 ? void 0 : _opt$onEnter2.call(opt, e);
    endListeners.resume();
  };

  const onDragEnter = e => {
    var _opt$onDragEnter2;

    (_opt$onDragEnter2 = opt.onDragEnter) === null || _opt$onDragEnter2 === void 0 ? void 0 : _opt$onDragEnter2.call(opt, e);

    if (!entered) {
      onEnter(e);
    }
  };

  const onDragOver = e => {
    var _opt$onDragOver2;

    if (!entered) {
      onEnter(e);
    }

    (_opt$onDragOver2 = opt.onDragOver) === null || _opt$onDragOver2 === void 0 ? void 0 : _opt$onDragOver2.call(opt, e);
  };

  const onDragLeave = e => {
    var _opt$onDragLeave2;

    (_opt$onDragLeave2 = opt.onDragLeave) === null || _opt$onDragLeave2 === void 0 ? void 0 : _opt$onDragLeave2.call(opt, e);

    const doLeave = function () {
      var _opt$onLeave2;

      let event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : e;
      entered = false;
      (_opt$onLeave2 = opt.onLeave) === null || _opt$onLeave2 === void 0 ? void 0 : _opt$onLeave2.call(opt, event);
      endListeners.stop();
    };

    if (e.target === el) {
      doLeave();
    } else {
      var _el$_onLeave_dragover;

      // @ts-ignore
      (_el$_onLeave_dragover = el._onLeave_dragover_destroy) === null || _el$_onLeave_dragover === void 0 ? void 0 : _el$_onLeave_dragover.call(el); // @ts-ignore

      const destroy = el._onLeave_dragover_destroy = hp.once(window, "dragover", e2 => {
        if (!hp.pointIn(e2.clientX, e2.clientY, el)) {
          doLeave(e2);
        }
      });
      setTimeout(() => {
        destroy();
      }, 1000);
    }
  };

  const onDrop = e => {
    var _opt$onDrop2;

    (_opt$onDrop2 = opt.onDrop) === null || _opt$onDrop2 === void 0 ? void 0 : _opt$onDrop2.call(opt, e);
  };

  const onEndBeforeLeave = e => {
    var _opt$onEndBeforeLeave;

    if (e instanceof KeyboardEvent) {
      if (e.key !== "Escape") {
        return;
      }
    }

    entered = false;
    endListeners.stop();
    (_opt$onEndBeforeLeave = opt.onEndBeforeLeave) === null || _opt$onEndBeforeLeave === void 0 ? void 0 : _opt$onEndBeforeLeave.call(opt, e);
  };

  const endListeners = hp.extendedListen([[el, "drop", onEndBeforeLeave], [window, "mouseup", onEndBeforeLeave], [window, "touchend", onEndBeforeLeave], [window, "keydown", onEndBeforeLeave]]);
  endListeners.stop();

  const resume = () => {
    hp.on(el, "dragenter", onDragEnter);
    hp.on(el, "dragover", onDragOver);
    hp.on(el, "dragleave", onDragLeave);
    hp.on(el, "drop", onDrop);
  };

  const destroy = () => {
    hp.off(el, "dragenter", onDragEnter);
    hp.off(el, "dragover", onDragOver);
    hp.off(el, "dragleave", onDragLeave);
    hp.off(el, "drop", onDrop);
    endListeners.stop();
  };

  resume();
  return destroy;
}

export { context, defaultOptions, extendedDND, extendedDropZone, instances };
